/**
 * Uncanny codes woo commerce customizations
 *
 * @author Uncanny Owl
 * @version 1.0.0
 */
jQuery( document ).ready( function ( $ ){

	// Then call these when the DOM is ready
	$( document ).ready( function (){
		const url_string = window.location.href;
		const url        = new URL( url_string );

		// Check if its the post edit
		if (
			url.searchParams.has( 'action' ) && 'edit' === url.searchParams.get( "action" ) ||
			url.searchParams.has( 'post_type' ) && 'product' === url.searchParams.get( "post_type" )
		) {
			// console.log( 'init' );
			// console.log( $( 'body' ).hasClass( 'post-type-product' ) );
			//check if we are editing a woo product
			if ($( 'body' ).hasClass( 'post-type-product' )) {
				// Lets go!
				UOC_WooType.init();
			}
		}
	} );

	let UOC_WooType = {
		init: function (){

			// Get elements
			this.getElements();

			this.setupUncannyCodesType();

			this.setCodesGroupID();

			// Add actions
			this.addActions();
		},

		getElements: function (){

			this.$elements = {
				// Product type select input
				product_type: jQuery( '#product-type' ),

				// header check boxes
				//virtual_label: jQuery( '#_virtual' ).parent(),
				virtual_input: jQuery( '#_virtual' ),
				//downloadable_label: jQuery( '#_downloadable' ).parent(),
				//downloadable_input: jQuery( '#_downloadable' ),

				// general tab elements
				general_tab: jQuery( '.product_data_tabs .general_tab' ),
				general_tab_link: jQuery( 'li.general_options a' ),
				general_pricing: jQuery( '#general_product_data .pricing' ),

				// Tax
				taxStatus: jQuery('.form-field._tax_status_field').parent(),
				taxClass: jQuery('.form-field._tax_class_field').parent(),

				// inventory tab elements
				inventory_options: $( '.inventory_options' ),
				inventory_manage_stock: $( '#_manage_stock' ),
				//inventory_manage_stock_fields: jQuery( '.stock_fields' ),
				inventory_manage_stock_field: $( '#inventory_product_data ._manage_stock_field' ),
				inventory_stock: jQuery( '#_stock' ),
				inventory_stock_status: jQuery( '#_stock_status' ),
				inventory_backorders: jQuery( '#_backorders' ),
				inventory_sold_individually_field: $( '#inventory_product_data ._sold_individually_field' ),


				// Custom codes fields
				codesGroupName: $( '#codes_group_name' ),
				codesGroupTotal: $( '#codes_group_total' ),
				codesGroupAvailable: $( '#codes_group_available' ),
				codesGroupEdit: $( '#codes_group_edit' ),
				codesGroupError: $( '#codes_group_error' ),

			}
		},

		setupUncannyCodesType: function (){

			// for header checkboxes
			//this.$elements.virtual_label.addClass( 'show_if_automator_codes' );
			//this.$elements.downloadable_label.addClass( 'show_if_automator_codes' );

			// for Price section
			this.$elements.general_pricing.addClass( 'show_if_automator_codes' );

			this.$elements.taxStatus.addClass('show_if_automator_codes');
			this.$elements.taxClass.addClass('show_if_automator_codes');

			// for Inventory tab
			//this.$elements.inventory_options.addClass( 'show_if_automator_codes' );
			this.$elements.inventory_manage_stock_field.addClass( 'show_if_automator_codes' );
			this.$elements.inventory_sold_individually_field.addClass( 'show_if_automator_codes' );
			this.$elements.inventory_sold_individually_field.parent().addClass( 'show_if_automator_codes' );

			// if the product initialize as a automator_codes product_type
			if ('automator_codes' === this.$elements.product_type.val()) {

				// show header virtual and downloadable check boxes and the check them by default
				 //this.$elements.virtual_label.show();
				 //this.$elements.virtual_input.trigger( 'click' );
				// this.$elements.downloadable_label.show();
				//
				//
				// // show general tab and fields
				 this.$elements.general_tab.show();
				 //this.$elements.general_tab_link.trigger( 'click' ); //Imitate general tab clicked
				 this.$elements.general_pricing.show();
				//
				// // show inventory tab and fields
				 this.$elements.inventory_options.show();
				 this.$elements.inventory_manage_stock_field.show();
				//
				// this.$elements.inventory_manage_stock.trigger( 'click' );
				// this.$elements.inventory_stock.prop( "disabled", true );
				 this.$elements.inventory_stock_status.prop( "disabled", true );
				 this.$elements.inventory_backorders.prop( "disabled", true );
				// this.$elements.inventory_backorders.val( "no" );
				// this.$elements.inventory_manage_stock_fields.show();
				// this.$elements.inventory_sold_individually_field.show();
				// this.$elements.inventory_sold_individually_field.parent().show();

				this.$elements.taxStatus.show(); //Show tax status
				this.$elements.taxClass.show(); //Show tax class fields

			}
		},

		setCodesGroupID: function (){
			// if the product initialize as a automator_codes product_type
			if ('automator_codes' === this.$elements.product_type.val()) {
				this.updateGroupCodesFields();
			}
		},

		addActions: function (){

			// console.log( 'add actions' );
			// Create reference to this object instance
			let _this = this;

			this.$elements.product_type.on( 'change', function ( event ){

				// console.log( 'change product type' );

				// _this.$elements.inventory_manage_stock.prop( "disabled", false );
				// _this.$elements.inventory_stock.prop( "disabled", false );
				// _this.$elements.inventory_stock_status.prop( "disabled", false );
				// _this.$elements.inventory_backorders.prop( "disabled", false );


				if ('automator_codes' === _this.$elements.product_type.val()) {
					// _this.$elements.virtual_input.prop( "checked", true );
					_this.$elements.inventory_manage_stock.trigger( 'click' );
					_this.$elements.virtual_input.trigger( 'click' );
					// _this.$elements.inventory_stock.prop( "checked", true ).prop( "disabled", true );
                    _this.$elements.inventory_stock_status.prop( "disabled", true );
                    _this.$elements.inventory_backorders.prop( "disabled", true );
					// _this.$elements.inventory_backorders.val( "no" );
					_this.$elements.inventory_options.show();
					// _this.$elements.inventory_manage_stock_fields.show();
					 _this.$elements.inventory_manage_stock_field.show();
					// _this.$elements.inventory_sold_individually_field.show();
					// _this.$elements.inventory_sold_individually_field.parent().show();
					_this.updateGroupCodesFields();
				}
			} );

			// Listen change of the group codes select input
			this.$elements.codesGroupName.on( 'change', function ( event ){
				// console.log( 'change group' );
				_this.updateGroupCodesFields();
			} );

			// Listen click to the edit code group button
			this.$elements.codesGroupEdit.on( 'click', function (){
				let ID  = $( this ).data( 'group' );
				let url = $( this ).data( 'href' );
				window.open( url + ID, '_blank' );
			} );
		},

		updateGroupCodesFields: function (){
			// console.log( 'updateGroupCodesFields' );
			UOC_WooType.$elements.codesGroupTotal.val( '' );
			UOC_WooType.$elements.codesGroupTotal.val( '' );
			UOC_WooType.$elements.codesGroupAvailable.val( '' );
			UOC_WooType.$elements.codesGroupEdit.data( 'group', this.$elements.codesGroupName.val() );
			UOC_Utilities.restCall();
		}

	};

	let UOC_Utilities = {
		restCall: function (){

			UOC_WooType.$elements.codesGroupTotal.val( "" );
			UOC_WooType.$elements.codesGroupAvailable.val( "" );

			$.ajax( {
					method: "GET",
					url: uoCodesStrings.root + '/get_codes_group_detail/' + UOC_WooType.$elements.codesGroupName.val() + '/',
					// Attach Nonce the the header of the request
					beforeSend: function ( xhr ){
						UOC_WooType.$elements.codesGroupName.attr( 'disabled', 'disabled' );
						UOC_WooType.$elements.codesGroupEdit.attr( 'disabled', 'disabled' );
						UOC_WooType.$elements.codesGroupError.hide();
						xhr.setRequestHeader( 'X-WP-Nonce', uoCodesStrings.nonce );
					}
				} )
				.done( function ( response ){
					if (true === response.success) {
						UOC_WooType.$elements.codesGroupTotal.val( response.total );
						UOC_WooType.$elements.codesGroupAvailable.val( response.available );
						UOC_WooType.$elements.inventory_stock.val( response.available );
						UOC_WooType.$elements.inventory_stock_status.val( response.stock_status );
					} else {
						UOC_WooType.$elements.codesGroupTotal.val( '' );
						UOC_WooType.$elements.codesGroupAvailable.val( '' );
						UOC_WooType.$elements.codesGroupError.first().html( response.message );
						UOC_WooType.$elements.codesGroupError.show().delay( 7000 ).fadeOut();
					}

				} )
				.fail( function ( response ){
					//_this.errorNotice( response );
				} )
				.always( function ( response ){
					UOC_WooType.$elements.codesGroupName.removeAttr( 'disabled' );
					UOC_WooType.$elements.codesGroupEdit.removeAttr( 'disabled' );
				} );
		},
	};
} );
